module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/external-link-da8455a88ecaf2593da1e3df635646c5.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/external-link.svg
// module id = wa6P
// module chunks = 24